module.exports = "//public.getcloudapp.com/packs/media/images/3-10892c812fc45774af78080e940ba4bc.png";